import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../common.css";
import "../investorAcademy.css";
import InvestorAcademyCommon from '../../../../components/common/InvestorAcademyCommon';



const SingleShareExpiries = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const location = useLocation();
  const history = useHistory();

  return (
    <div id="investor_academy">
      <div className="imgbg" />
      <div className="mainbg"></div>
      <div
        id="main"
      >
        <div
          id="maintable" className='Common_warrent'
          style={{ display: "table", width: "100%", tableLayout: "fixed" }}
        >
          <div style={{ display: "table-row" }}>
            <div
              id="leftbar"
              className="hidden-xs"
              style={{ display: "table-cell", width: "80px" }}
            />



            <div id="maincontainer" style={{ display: "table-cell", width: "100%" }}>
              <div id="mainnav">
                <table
                  style={{
                    width: "100%",
                    tableLayout: "fixed",
                    borderBottom: "1px solid #353223",
                  }}
                >
                  <tbody>
                    <tr>
                      <td width="20%" style={{ textAlign: "left", visibility: "hidden" }}>
                        <table
                          className="hasprev hidden-xs"
                          style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <td width="33px">
                                <div className="prev left" />
                              </td>
                              <td>
                                <div className="prevlbl left">
                                  <div
                                    className="prevtitle "
                                    style={{ textAlign: "left" }}
                                  />
                                  <div className="prevname " style={{ textAlign: "left" }}>
                                    Tips and Tools
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td width="60%" style={{ textAlign: "center" }}>
                        <div
                          id="pagetitlediv"
                          style={{
                            width: "365px",
                            height: "100%",
                            borderBottom: "1px solid #FFD843",
                            margin: "auto",
                          }}
                        >
                          <div
                            id="ptitle"
                            style={{
                              fontFamily: "HelveticaNeueThinCond",
                              fontSize: "25px",
                              color: "white",
                              letterSpacing: "1px",
                            }}
                          >
                            <img height="56px" src='/img/education/08.png' alt="image" />
                          </div>
                          <div
                            id="pname"
                            style={{
                              fontFamily: "HelveticaNeueThinCond",
                              fontSize: "30px",
                              color: "#FFD843",
                              letterSpacing: "1px",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                            }}
                          >
                            Single share calls and puts at expiry
                          </div>
                        </div>
                      </td>
                      <td width="20%" style={{ textAlign: "right", visibility: "hidden" }}>
                        <table
                          className="hasnext  hidden-xs"
                          style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                        >
                          <tbody>
                            <tr>
                              <td>
                                <div className="nextlbl right">
                                  <div
                                    className="nexttitle "
                                    style={{ textAlign: "right" }}
                                  />
                                  <div className="nextname " style={{ textAlign: "right" }}>
                                    Last trading day
                                  </div>
                                </div>
                              </td>
                              <td width="33px">
                                <div className="next right" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                id="maincontent"
                style={{
                  marginLeft: "10px",
                  marginRight: "10px",
                  paddingTop: "40px",
                  marginBottom: "60px",
                }}
              >
                <div
                  id="mainscroll"
                  style={{
                    height: "100%",
                    overflowX: "hidden",
                    overflowY: "auto",
                    paddingLeft: "90px",
                    paddingRight: "90px",
                  }}
                >
                  <div id="mainscrollcontent">
                    <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                    <title>Single share calls and puts at expiry</title>
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\n            .hex{\n               margin-bottom: -28px\n            }\n            .hexrow.odd{\n                margin-left:253px;\n            }\n            .hexrow.even{\n                margin-left: 62px;\n            }\n            .hex .hexbody{\n                width:120px;\n                height:68px;\n            }\n            .hex .hextop {\n                width: 0;\n                border-bottom: 35px solid;\n                border-left: 60px solid transparent;\n                border-right: 60px solid transparent;\n            }\n            .hex .hexbottom {\n                width: 0;\n                border-top: 35px solid;\n                border-left: 60px solid transparent;\n                border-right: 60px solid transparent;\n            }\n            .hexmenu{\n                width: 512px;\n            }\n        ",
                      }}
                    />
                    <div className="contentbox">
                      <p className="showtile">
                        Please click on each of the tiles below for more details
                      </p>
                      <div className="hexmenu hide_mobile">
                        <div className="hexrow odd">
                          <div
                            className="hex color05"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/single-share-calls/put-expiry-formula">
                              <span className="text-black ">Put expiry Formula</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                          <div
                            className="hex color05"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/single-share-calls/put-example">
                              <span className="text-black ">Put example</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                        </div>
                        <div className="hexrow even">
                          <div
                            className="hex color04"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/single-share-calls/call-expiry-formula">
                              <span className="text-black "> Call expiry Formula</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                          <div
                            className="hex color04"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/single-share-calls/call-example">
                              <span className="text-black "> Call example</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                        </div>
                        <div className="hexrow last">
                          <div
                            className="hex color01 last"
                          >
                            <div className="hextop" />
                            <div className="hexbody"><Link to="/edu/single-share-calls/last-trading-day">
                              <span className="text-black ">Last trading day</span>
                            </Link></div>
                            <div className="hexbottom" />
                          </div>
                        </div>
                      </div>
                      <div className='square_hex'>
                        <div
                          className="hex1">
                          <div>
                            <Link to="/edu/single-share-calls/last-trading-day">
                              <img src='/img/education/warrants_at_expiry.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                            <Link to="/edu/single-share-calls/last-trading-day">
                              <span className="text-black ">Last trading day</span>
                            </Link>
                          </div>
                          <div>
                            <Link to="/edu/single-share-calls/last-trading-day">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                        
                        <div
                          className="hex1">
                          <div>
                            <Link to="/edu/single-share-calls/call-expiry-formula">
                              <img src='/img/education/formula_to_alculate_value_of_call.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                            <Link to="/edu/single-share-calls/call-expiry-formula">
                              <span className="text-black "> Call expiry Formula</span>
                            </Link>
                          </div>
                          <div>
                            <Link to="/edu/single-share-calls/call-expiry-formula">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                        <div
                          className="hex1">
                          <div>
                            <Link to="/edu/single-share-calls/call-example">
                              <img src='/img/education/single_stock_call_warrant_example.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                            <Link to="/edu/single-share-calls/call-example">
                              <span className="text-black "> Call example</span>
                            </Link>
                          </div>
                          <div>
                            <Link to="/edu/single-share-calls/call-example">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>

                        <div
                          className="hex1">
                          <div>
                            <Link to="/edu/single-share-calls/put-expiry-formula">
                              <img src='/img/education/formula_to_alculate_value_of_call.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                            <Link to="/edu/single-share-calls/put-expiry-formula">
                              <span className="text-black ">Put expiry Formula</span>
                            </Link>
                          </div>
                          <div>
                            <Link to="/edu/single-share-calls/put-expiry-formula">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                        <div
                          className="hex1">
                          <div>
                            <Link to="/edu/single-share-calls/put-example">
                              <img src='/img/education/single_stock_call_warrant_example.png' alt="image" />
                            </Link>
                          </div>

                          <div>
                            <Link to="/edu/single-share-calls/put-example">
                              <span className="text-black ">Put example</span>
                            </Link>
                          </div>
                          <div>
                            <Link to="/edu/single-share-calls/put-example">
                              <img src='/img/education/arrow.png' />
                            </Link>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="rightbar"
                  className="hidden-xs"
                  style={{ display: "table-cell", width: "80px" }}
                ></div>
              </div>
            </div>



            <div
              id="rightbar"
              className="hidden-xs"
              style={{ display: "table-cell", width: "80px" }}
            ></div>
          </div>
        </div>
      </div>


      <div
        id="bottom"
        style={{
          position: "fixed",
          width: "100%",
          bottom: "0px",
          height: "40px",
          backgroundColor: "#101010",
          zIndex: 10000,
        }}
      >
        <div
          className="hidden-xs hidden-xxs"
          style={{
            display: "table",
            width: "100%",
            textAlign: "center",
            color: "#8F8F8F",
            fontSize: "11px",
            lineHeight: "40px",
          }}
        >
          <div className='copyright_sec'>
            Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
            reserved.
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            width: "46%",
            height: "35px",
            right: "10px",
            bottom: "5px",
          }}
        >
          <table
            className="hasnext"
            style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
          >
            <tbody>
              <tr>
                <td>
                  <div className="nextlbl right">
                    <div
                      className="nextname "
                      style={{ textAlign: "right", fontSize: "15px" }}
                    >
                      <Link to="/edu/single-share-calls/last-trading-day">
                        <span className="prevname "> Last trading day</span>
                      </Link>
                    </div>
                  </div>
                </td>
                <td width="33px">
                  <Link to="/edu/single-share-calls/last-trading-day">
                    <div className="next right" />
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{
            position: "absolute",
            width: "46%",
            height: "35px",
            left: "10px",
            bottom: "5px",
          }}
        >
          <table
            className="hasprev"
            style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
          >
            <tbody>
              <tr>
                <td width="33px">
                  <Link to="/edu/select-warrant/tips-and-tool">
                    <div className="prev left" />
                  </Link>
                </td>
                <td>
                  <div className="prevlbl left">
                    <div
                      className="prevname "
                      style={{ textAlign: "left", fontSize: "15px" }}
                    >
                      <Link to="/edu/select-warrant/tips-and-tool">
                        <span className="prevname "> Tips and Tools</span>
                      </Link>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
        {/* <div className="dbtn dbtn-seminarbtn">
          <Link
            className="seminarbtn"
            to="/education/seminar"
          >
            <img src='/img/education/button-static.png' alt="image" />
          </Link>
        </div> */}
        <InvestorAcademyCommon Location={location} Hist={history} />
      </div>

    </div>
  );
}
export default SingleShareExpiries;